import { BitwiseHelper, Message } from '@ncss/message';
import { ByteList } from 'byte-list';

export enum NL4UpdateStatusMessageType {
  GROUP_MASK = 0x1730,
  STATUS_MESSAGE = 0x1730,
}

export enum UpdateError {
  NONE = 0,
  DEVICE_TYPE = 1,
  SIZE = 2,
  INFO_CHANGED = 3,
  WRITE_FLASH = 4,
  TAG = 5,
  SAME_VERSION = 6,
}

export class NL4UpdateStatusMessage extends Message {
  deviceTypeId = 0;
  firmwareVersionMajor = 0;
  firmwareVersionMinor = 0;
  transferId = 0;
  swd = false;
  currentBlock = 0;
  error = UpdateError.NONE;

  serialize(): ByteList {
    const bytes = super.serialize();
    bytes.writeByte(this.deviceTypeId);
    bytes.writeByte(this.firmwareVersionMajor);
    bytes.writeByte(this.firmwareVersionMinor);
    let flags = 0;
    flags = BitwiseHelper.SetBits(flags, 0, 7, this.transferId);
    flags = BitwiseHelper.SetBits(flags, 7, 1, +this.swd);
    bytes.writeByte(this.transferId);
    bytes.writeUInt16(this.currentBlock);
    bytes.writeByte(this.error);
    return bytes;
  }

  deserialize(bytes: ByteList): void {
    super.deserialize(bytes);
    this.deviceTypeId = bytes.readByte();
    this.firmwareVersionMajor = bytes.readByte();
    this.firmwareVersionMinor = bytes.readByte();
    const flags = bytes.readByte();
    this.transferId = BitwiseHelper.GetBits(flags, 0, 7);
    this.swd = !!BitwiseHelper.GetBits(flags, 7, 1);
    this.currentBlock = bytes.readUInt16();
    this.error = bytes.readByte() as UpdateError;
  }
}
